import React, { useCallback } from 'react';
import { Link, TableCell } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ComputedRoute } from 'utils/ComputedRoute';
import { IItem } from 'api/catalog/models';
import { ProductListingColumn, useItemRendering } from 'hooks';

import AssetDataCell from '../AssetDataCell';

interface IProps {
  column: ProductListingColumn;
  item: IItem;
}

const ProductDataCell = ({ column, item }: IProps) => {
  const { getCommonAttributeRender } = useItemRendering();
  const renderCell = useCallback(
    (item: IItem, column: ProductListingColumn): React.ReactNode => {
      switch (column.id) {
        case 'itemNumber':
          return (
            <Link
              component={RouterLink}
              to={ComputedRoute.getProductDetailsRoute(item.elasticId)}
            >
              {item.itemNumber}
            </Link>
          );
        case 'assets':
          return <AssetDataCell assets={item.assets} />;
        default:
          return getCommonAttributeRender(item, column.id);
      }
    },
    [getCommonAttributeRender]
  );

  return <TableCell align={column.align}>{renderCell(item, column)}</TableCell>;
};

export default ProductDataCell;
